<section class="anexos" aria-labelledby="anexos-titulo">
  <h2 class="anexos-titulo-oculto" id="anexos-titulo">Anexos da solicitação</h2>

  @if (!permiteAnexos()) {
    <p class="anexos-texto anexos-sem" role="status">
      <i-lucide name="info" size="18" aria-hidden="true"></i-lucide>
      Este serviço não recebe anexos. Você pode avançar para a confirmação.
    </p>
  } @else {
  <p class="anexos-texto">{{ orientacao() }}</p>

  <p class="anexos-regras" id="anexos-regras">
    {{ resumoRegras() }}
    @if (obrigatorio()) {
      <strong>O envio de ao menos um anexo é obrigatório.</strong>
    }
  </p>

  @if (recusas().length) {
    <ul class="anexos-recusas" role="alert">
      @for (recusa of recusas(); track $index) {
        <li>{{ recusa }}</li>
      }
    </ul>
  }

  @if (pendenciaObrigatorio()) {
    <p class="anexos-recusas" role="alert">Anexe ao menos um arquivo para avançar.</p>
  }

  <label
    class="anexos-area"
    [attr.data-arrastando]="arrastando()"
    (dragover)="aoArrastar($event)"
    (dragleave)="aoSairDaArea()"
    (drop)="aoSoltar($event)"
  >
    <input
      class="anexos-campo"
      type="file"
      multiple
      [attr.accept]="accept()"
      [disabled]="lotado()"
      aria-describedby="anexos-regras"
      (change)="aoSelecionar($event)"
    />

    <i-lucide class="anexos-area-icone" name="upload" size="26" aria-hidden="true"></i-lucide>

    <span class="anexos-area-titulo">
      @if (arquivos().length) {
        {{ arquivos().length }} arquivo(s) escolhido(s)
      } @else {
        Nenhum arquivo escolhido
      }
    </span>

    <span class="anexos-area-texto">
      @if (lotado()) {
        Limite de arquivos atingido. Remova um para trocar.
      } @else {
        Arraste e solte ou clique para selecionar arquivos
      }
    </span>
  </label>

  <table class="anexos-tabela">
    <caption class="anexos-titulo-oculto">Arquivos anexados</caption>
    <thead>
      <tr>
        <th scope="col">Nome</th>
        <th scope="col">Tamanho</th>
        <th scope="col">Ações</th>
      </tr>
    </thead>
    <tbody>
      @for (arquivo of arquivos(); track arquivo.id) {
        <tr>
          <td>{{ arquivo.nome }}</td>
          <td>{{ formatarTamanho(arquivo.tamanho) }}</td>
          <td>
            <button
              type="button"
              class="anexos-remover"
              [attr.aria-label]="'Remover ' + arquivo.nome"
              (click)="remover(arquivo.id)"
            >
              <i-lucide name="trash-2" size="16" aria-hidden="true"></i-lucide>
            </button>
          </td>
        </tr>
      } @empty {
        <tr>
          <td class="anexos-vazio" colspan="3">Nenhum arquivo anexado</td>
        </tr>
      }
    </tbody>
  </table>
  }
</section>
